import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  },
  children: {},
  header: {
    position: 'absolute',
    top: 0,
    textAlign: 'center',
    transform: 'translateY(-100%)',
    whiteSpace: 'pre-wrap',
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    textAlign: 'center',
    transform: 'translateY(100%)',
    whiteSpace: 'pre-wrap',
  },
});

function SequenceBarItem({
  children,
  className,
  classes,
  footer,
  header,
  style,
}) {
  return (
    <div className={classNames(classes.root, className)} style={style}>
      {header && <div className={classes.header}>{header}</div>}
      <div className={classes.children}>{children}</div>
      {footer && <div className={classes.footer}>{footer}</div>}
    </div>
  );
}

SequenceBarItem.defaultProps = {
  className: '',
  footer: null,
  header: null,
  style: null,
};

SequenceBarItem.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  footer: PropTypes.node,
  header: PropTypes.node,
  style: PropTypes.object,
};

export default withStyles(styles, { name: 'SequenceBarItem' })(SequenceBarItem);
